import { Injectable } from "@angular/core";

import { environment } from "../../environments/environment";

export class User {
  constructor(
    public userId: number,
    public username: string,
    public password: string,
    public role: string
  ) {}
}

@Injectable({
  providedIn: "root"
})
export class AuthService {
  private redirectUrl: string = "/";
  private loginUrl: string = "/login";

  constructor() {}

  isUserLoggedIn(): boolean {
    if (localStorage.getItem("access_token")) return true;
    else return false;
  }
  getUserToken(): string {
    return localStorage.getItem("userToken");
  }
  getRedirectUrl(): string {
    return this.redirectUrl;
  }
  setRedirectUrl(url: string): void {
    this.redirectUrl = url;
  }
  getLoginUrl(): string {
    return this.loginUrl;
  }
  logoutUser(): void {
    localStorage.clear();
    sessionStorage.clear();
  }
}
